const API = process.env.REACT_APP_API_URL;

// Получение текущего языка из URL
const getCurrentLanguage = () => {
  const pathSegments = window.location.pathname.split('/');
  if (pathSegments[1] && /^[a-z]{2}$/.test(pathSegments[1])) {
    return pathSegments[1];
  }
  return 'en'; // По умолчанию английский
};

// Получение языка из cookie
const getLanguageFromCookie = () => {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith('django_language=')) {
      return cookie.substring('django_language='.length, cookie.length);
    }
  }
  return null;
};

// Функция для получения CSRF токена из cookies
export const getCsrfToken = () => {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith('csrftoken=')) {
      return cookie.substring('csrftoken='.length, cookie.length);
    }
  }
  return '';
};

// Функция для обновления CSRF токена
export const refreshCsrfToken = async () => {
  await fetchWithLanguage('/api/auth/csrf/', {
    method: 'GET',
  });
  return getCsrfToken();
};

// Функция для выполнения запросов с правильными заголовками
export const fetchWithLanguage = async (endpoint, options = {}) => {
  // Используем язык из URL или cookie, URL имеет приоритет
  const language = getCurrentLanguage() || getLanguageFromCookie() || 'en';
  
  // Создаем новый объект options с credentials: 'include' по умолчанию
  const updatedOptions = {
    ...options,
    credentials: 'include', // Всегда отправляем cookies с запросом
  };
  
  // Настраиваем заголовки - WITHOUT CSRF token as we've disabled CSRF in the backend
  const headers = {
    'Accept-Language': language,
    'Content-Language': language,
    'Content-Type': 'application/json',
    ...updatedOptions.headers,
  };
  
  // Ensure we don't have X-CSRFToken header
  // if (headers['X-CSRFToken']) {
  //   delete headers['X-CSRFToken'];
  // }
  
  // Полный URL API с проверкой наличия слеша в начале endpoint
  const apiUrl = `${API}${endpoint.startsWith('/') ? endpoint : '/' + endpoint}`;
  
  try {
    console.log(`Fetching ${apiUrl}`, { method: updatedOptions.method || 'GET' });
    
    const response = await fetch(apiUrl, {
      ...updatedOptions,
      headers,
    });
    
    // Handle non-200 responses
    if (!response.ok) {
      let errorData = {};
      try {
        errorData = await response.json();
      } catch (parseError) {
        console.error('Error parsing error response:', parseError);
      }
      
      const errorMessage = errorData.error || response.statusText || `Request failed with status ${response.status}`;
      console.error(`API error (${response.status}):`, errorData);
      throw new Error(errorMessage);
    }
    
    // For 204 No Content responses, return null instead of trying to parse JSON
    if (response.status === 204) {
      return null;
    }
    
    return await response.json();
  } catch (error) {
    console.error(`Error fetching ${endpoint}:`, error);
    throw error;
  }
};
